"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var RemoveRedEye_1 = __importDefault(require("@mui/icons-material/RemoveRedEye"));
var Delete_1 = __importDefault(require("@mui/icons-material/Delete"));
var IconButton_1 = __importDefault(require("@mui/material/IconButton"));
var ListItemButton_1 = __importDefault(require("@mui/material/ListItemButton"));
var Component = function (p) {
    var pointer = p.visible ? 'all' : 'none';
    return (Preact.h(Box_1.default, { sx: __assign(__assign({}, p.sx), { background: p.selected ? 'rgba(251, 53, 104, 0.08)' : '#fafafa', display: 'flex', justifyContent: 'center', alignItems: 'center' }) },
        Preact.h(ListItemButton_1.default, { onClick: p.onSelectClick, sx: { pointerEvents: pointer } },
            Preact.h(Typography_1.default, { sx: { ml: 3, flexGrow: 1 } }, p.name),
            Preact.h(IconButton_1.default, { onClick: function (e) {
                    e.stopPropagation();
                    p.onViewClick();
                }, sx: { pointerEvents: 'all' } },
                Preact.h(RemoveRedEye_1.default, { sx: { color: p.visible ? 'primary.main' : 'rgba(4, 4, 6, 0.26)' } })),
            Preact.h(IconButton_1.default, { onClick: function (e) {
                    e.stopPropagation();
                    return p.onDeleteClick();
                }, sx: { pointerEvents: 'all' } },
                Preact.h(Delete_1.default, null)))));
};
exports.Component = Component;
